import React, { useState } from 'react';
import API from '../services/api';
import '../styles/DebtForm.css';


export default function DebtForm({ onAdd }) {
  const [form, setForm] = useState({ debtor_name: '', amount: '', description: '', date: '' });

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    await API.post('/debts', form);
    onAdd();
    setForm({ debtor_name: '', amount: '', description: '', date: '' });
  };

  return (
<form className="form-container" onSubmit={handleSubmit}>
  <input
    name="debtor_name"
    placeholder="Nama"
    value={form.debtor_name}
    onChange={handleChange}
    className="form-input"
  />
<input
  name="amount"
  type="text"
  placeholder="Jumlah"
  value={form.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
  onChange={e => {
    const rawValue = e.target.value.replace(/\./g, '').replace(/[^0-9]/g, '');
    setForm({ ...form, amount: rawValue });
  }}
/>

  <input
    name="description"
    placeholder="Catatan"
    value={form.description}
    onChange={handleChange}
    className="form-input"
  />
  <input
    name="date"
    type="date"
    value={form.date}
    onChange={handleChange}
    className="form-input"
  />
  <button type="submit" className="form-button">Tambah</button>
</form>

  );
}
